import { useEffect, useState } from "react";
import LoadingStuck from "../../reuse/LoadingStuck";
import { useParams } from "react-router";
import Api from "../../../api/Api";
import { Button, Card, Col, Modal, Nav, Offcanvas, Row } from "react-bootstrap";
import { BsFloppy, BsInfoCircle, BsJournalText } from "react-icons/bs";
import { auditTypes } from "../../../constants/auditTypes";
import { ShortNamesOfTestCategories } from "../../reuse/ShortNamesOfTestCategories";
import { CreateLocalSaving } from "./CreateLocalSaving";
import { TransformSendData } from "./TransformSendData";
import AuditInterface from "./AuditInterface";
import { saveAuditResult } from "./saveAuditResult";


const getAudit = async(auditId) => {
    try {
        const response = await Api({
            method:"get",
            url:`/audits/@${auditId}`,
            headers:{}
        })
        return(response.data);
    } catch (error) {
        throw error
    }
}

const createLocalSave = (data) => {
    const local_saving_data=CreateLocalSaving(data.data);
    localStorage.setItem(`save_${data.id}`, JSON.stringify(local_saving_data));
    console.log("создано локальное сохранение")
}

const ModalWarning = () => {
    const {audit_id}=useParams();
    const handleSaveData = async() => {
        await saveAuditResult(audit_id);
    }

    const handleClearReload = () => {
        // console.log("Проверка 2")
        localStorage.removeItem(`save_${audit_id}`);
        window.location.reload()
    }
    return(
        <div
        className="modal show"
        style={{ display: 'block', position: 'initial' }}
        >
        <Modal.Dialog>
            <Modal.Header>
            <Modal.Title className="text_font">Найдены неотправленные данные</Modal.Title>
            </Modal.Header>

            <Modal.Body>
            <p className="text_font">Обнаружены неотправленные данные. Отправить данные?</p>
            <div>
                <Row>
                    <Col md={6}>
                        <Button 
                        className="free-btn mb-1" 
                        variant="light" 
                        onClick={()=>{handleSaveData()}}>Да, отправить</Button>
                    </Col>
                    <Col md={6}>
                        <Button 
                        className="free-btn mb-1 " 
                        variant="light"
                        onClick={()=>{handleClearReload()}}>Нет, очистить и перезагрузить</Button>
                    </Col>
                </Row>
            </div>
            </Modal.Body>
        </Modal.Dialog>
        </div>
    )
}

const CheckLocalStorage = ({data}) => {
    if(localStorage.getItem(`save_${data.id}`)==null || JSON.parse(localStorage.getItem(`save_${data.id}`)).saving==false){
        createLocalSave(data);
        return(<AuditInterface data={data}/>)
    }

    return(<ModalWarning/>)
}

const FetchDataAudit = () => {
    const [loading,setLoading]=useState(false);
    const [error, setError]=useState(false);
    const [block, setBlock]=useState(false);

    const [errorInfo,setErrorInfo]=useState(null);
    const [data,setData]=useState(null);

    const {audit_id}=useParams()

    useEffect(()=>{
        const setUp = async() =>{
            setLoading(true);
            try {
                const response = await getAudit(audit_id)
                setData(response);
                setBlock(true);
            } catch (error) {
                setErrorInfo(`Ошибка при подгрузке данных об аудите ${audit_id}. \n ${error}`)
                setError(true)
            }
            setLoading(false);
        };
        setUp();
    },[])

    if(loading){return(<LoadingStuck/>)}
    if(error){return(<><p className="warning_text sepatate_text">{errorInfo}</p></>)}
    if(block){return(<CheckLocalStorage data={data}/>)}
}

const AuditBlock = () => {
    return(<FetchDataAudit/>)
}

export default AuditBlock;